import { Env } from './env';
import { regions } from './region/regions';
import { initBranding } from './branding/init-branding';

export const getApis = () => {
  const apis = [
    { value: 'stg', text: 'Staging API', cst: 'https://staging-customertoolkit.riamoneytransfer.com/', remittance: 'https://staging-public.riamoneytransfer.com/', logApi: 'https://staging-logs.riamoneytransfer.com/'  },
    { value: 'prod', text: 'Production API', cst: 'https://customertoolkit.riamoneytransfer.com/', remittance: 'https://public.riamoneytransfer.com/', logApi: 'https://logs.riamoneytransfer.com/'  },
    { value: 'prod_nc', text: 'Production NC', cst: 'https://nc-customertoolkit.riamoneytransfer.com/', remittance: 'https://nc-public.riamoneytransfer.com/', logApi: 'https://staging-logs.riamoneytransfer.com/'  },
    { value: 'prod_oh', text: 'Production OH', cst: 'https://oh-customertoolkit.riamoneytransfer.com/', remittance: 'https://oh-public.riamoneytransfer.com/', logApi: 'https://staging-logs.riamoneytransfer.com/'  },
    { value: 'pilot', text: 'Pilot', cst: 'https://pre-nc-customertoolkit.riamoneytransfer.com/', remittance: 'https://pre-nc-public.riamoneytransfer.com/', logApi: 'https://staging-logs.riamoneytransfer.com/'  },
    { value: 'pilot_p1', text: 'Pilot P1', cst: 'https://p1-customertoolkit.riamoneytransfer.com/', remittance: 'https://p1-public.riamoneytransfer.com/', logApi: 'https://staging-logs.riamoneytransfer.com/'  },
    { value: 'qa01_core', text: 'QA01 CST Core', cst: 'https://qa01-cstcore.riamoneytransfer.com/', remittance: 'https://qa01-public.riamoneytransfer.com/', logApi: 'https://staging-logs.riamoneytransfer.com/'  },
    { value: 'stg_core', text: 'Staging CST Core', cst: 'https://staging-cstcore.riamoneytransfer.com/', remittance: 'https://staging-public.riamoneytransfer.com/', logApi: 'https://staging-logs.riamoneytransfer.com/'  },
  ]
  const envQuantity = 50;
  for (let i = 0; i <= envQuantity; i++) {
    const number = String(i).length > 1 ? i : '0'+i;
    apis.push({ value: `QA${number}`, text: `QA${number} API`, cst: `https://qa${number}-customertoolkit.riamoneytransfer.com/`, remittance: `https://qa${number}-public.riamoneytransfer.com/`, logApi: 'https://staging-logs.riamoneytransfer.com/'  })
  }
  return apis;
}

export const config = {
  env: Env.STG,
  RMT5_LEGACY_MODE: false, // CI-managed default; QA menu toggle overrides at runtime (non-PROD only)

  // MyRia
  API_URL: 'https://staging-customertoolkit.riamoneytransfer.com/',
  GOOGLE_API_KEY: 'AIzaSyCJw2B5N3WKty6F7pRJNP2vd47w4I6R1Hk',
  GOOGLE_ANALYTICS_ID: 'UA-93337072-1',
  IDNOW_COMPANY_ID: 'riafinancial',
  REMARKETING_TRACKING_ID: '834903991',
  REMARKETING_WEB: 'https://www.googleadservices.com/pagead/conversion/',
  PRIVACY_POLICY: 'http://www.riafinancial.com/global/privacy-policy',
  TERMS_AND_CONDITIONS: 'http://www.riafinancial.com/global/terms-and-conditions',
  TERMS_AND_CONDITIONS_PL: 'http://myriaapp.com/pl/TermsAndConditionsTransaction-pl.html',
  PRIVACY_POLICY_EKYC: 'http://myriaapp.com/es/PrivacyPolicyEKYC-es.html',
  EURONET_WW: 'http://www.euronetworldwide.com/',
  APP_STORE_ID: '1238779356',
  ITERABLE_INAPP_API: "https://api.iterable.com/",
  ITERABLE_INAPP_API_KEY: "b275c7b2ddda453aa998024765760861",
  PUBLIC_SITE: 'https://qa-rps-public-site.rps-digital.workers.dev/',
  // RMT
  //remittanceApiBaseUrl: 'https://rmt3-qa03-api.riamoneytransfer.com/',
  //remittanceApiBaseUrl: 'https://rmt3-mobile-api.riamoneytransfer.com/',
  //remittanceApiBaseUrl: 'https://rmt3-staging-api.riamoneytransfer.com/',
  remittanceApiBaseUrl: 'https://staging-public.riamoneytransfer.com/',
  dingBaseUrl: 'https://checkout-ria.dingstag.com/',
  dingOrigin: 'https://checkout-ria.dingstag.com',
  // Ria-hosted page that iframes Ding; null opens Ding top-level directly
  dingHostedCheckoutUrl: 'https://staging-secure.riamoneytransfer.com/topup/ding/checkout.html',
  logsApiUrl: 'https://staging-logs.riamoneytransfer.com/',
  phpApiBaseUrl: '',
  XForwardFor: '66.82.123.234',
  fingerprintClientId: 'RMT',
  fingerprintClientSecret: '19qAs2VD0Un1tch54!!',
  threatMetrix: {
    url: 'https://h.online-metrix.net/tags',
    credentials: 'l6ixtwpr',
    pageId: '1',
  },
  timeoutTimerWarning: 540,
  timeoutTimer: 600,
  timeoutRelogin: 10800,
  timeoutGeolocation: 5000,
  maps: {
    baseUrl: 'https://api.mapbox.com/mapbox-gl-js/v2.2.0/mapbox-gl.js',
    apiKey: 'pk.eyJ1IjoiYXBpZWwtcmlhZmluYW5jaWFsIiwiYSI6ImNrbmIyeW0xZzB5d2MycHBqcmZ4bTZrbGgifQ.GLHYhlNaghB6obkBoJ5fkA',
    geoCoderUrl: 'https://unpkg.com/@mapbox/mapbox-sdk/umd/mapbox-sdk.min.js',
    styleSheet: 'https://api.mapbox.com/mapbox-gl-js/v2.2.0/mapbox-gl.css'
  },
  connectionTimeoutSettings: {
    requestTimeoutThreshold: 30,
  },
  loadingTimeoutMs: 40000,
  features: {
    logging: false,
  },
  regions: [regions.US, regions.CA, regions.FR, regions.DE, regions.IT, regions.LU, regions.BE, regions.NL, regions.AT, regions.IE, regions.DK, regions.FI, 
    regions.SE, regions.NO, regions.UK, regions.ES, regions.LT, regions.CL, regions.AU, regions.NZ, regions.MY, regions.CH, regions.PT, regions.PL, regions.GR, regions.CZ, regions.SG,regions.SN, regions.RO, regions.PR],
  region: regions.US,
  paymentKycCheckRegions: [regions.MY , regions.SG],
  iovationScript: 'https://ci-mpsnare.iovation.com/snare.js',
  visaDirectScript: 'https://securepaytest.epayworldwide.com/visadirect/visadirect.js',
  cardinalScript: 'https://songbirdstag.cardinalcommerce.com/edge/v1/songbird.js',
  cardinalScriptV2: 'https://cas.static.client.cardinaltrusted.com/songbird/v2.1.3/songbird.js',
  enableLogToConsole: true,
  analyticsSettings: {
    segment: {
      methods: ['trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug', 'page', 'once', 'off', 'on'],
      baseUrl: 'https://cdn.segment.com/analytics.js/v1/',
      apiKey: 'Qtj6AcjP9TkKM0jfUlVCoissQhhq0scK',
    },
    businessUnit: 'RIA',
  },
  market: {
    androidUrl: 'https://play.google.com/store/apps/details?id=com.ria.moneytransfer',
    iosUrl: 'https://apps.apple.com/us/app/ria-money-transfer/id1065921908',
  },
  localProxy: false,
  otpTestPhoneNumber: null,
  logrocket: {
    key: '1sz4y0/rstg',
    console: {
      isEnabled: {
        log: true,
        debug: true,
      },
      shouldAggregateConsoleErrors: true, //Surface Console Errors in LogRocket
    },
    dom: {
      isEnabled: true,  //disable|enable all DOM recording
      inputSanitizer: false, // obfuscate all user-input elements <select> and <input>
    },
    network: {
      isEnabled: true,
    }
  },
  recaptchaKey: 'b5248f46-3913-406e-bc2e-82886f7a7700',
  featureFlags: {
    findLocationRevamp: true,
    validationUpdatePhoneV2: true,
    lokaliseContent: true,
    emailageValidation: false,
    kroger: false,
    captcha: true,
    signinOld: false,
    showNewHomePage: true,
    recipientInteractionEventEnabled: true,
    usAuthPluginPasswordHint: false,
    checkPromosV2: false,
    useApplePayCreditSelect: true,
  },
  vueBridgeLocalUrl: null,
  recipientInteractionEventEndDate: "2025-05-31",
  automationTest: false,
  amplitudeHeader: false,
  previewFrame: false,
  showDebug: true,
  enforceRefresh:true,
  liteRegisterationMY: false,
  showActivityCarousel: true,
  showTransferStatusWidget: false,
  checkOriginalCountry: false,
  branding: initBranding,
  
  // Fintoc 
  FintocPublicKey:'pk_test_vKUmsQW5vxn_fqSKCaJxpsuVozfvK9_8',
  WalletCardChannelId: "MOBILEAPP",
  WalletCardChannelPassword: "Welcome1*",
  zenDeskConfig:{
    agentAvailabilityurl:'https://launchpad-api-staging.xe.com/care/agentavailability',
    integrationId: '663182a9f91ae6d89a2b1d37',
    brandId: "24646249366673"
  },

  apis: getApis(),
  selectedApi: null,
  reminderInterval: 'Monthly',
  contentConfigs: {},
  microBlinkLicenseKeys: {
    android: 'sRwCABVjb20ucmlhLm1vbmV5dHJhbnNmZXIAbGV5SkRjbVZoZEdWa1QyNGlPakUzTlRrME16QTNNVE13TkRBc0lrTnlaV0YwWldSR2IzSWlPaUl3Tm1RMlltVTFZUzAwTURRMkxURTBNek10WkRnM01DMW1ZVE16TXpZd01ETTNaRElpZlE9PUUyyNDfCe1cj81QmmhP0LLx2QXcw7oAP2UNKfNt9hYd/c3IruTkURsOUk+0l747WvWm58rYs3Bo88ii1DtYDRpoO3QnqQbc/lEhCRlx7kXkgXseI5vibG5i7d6RH3I=',
    ios: 'sRwCABhjb20ucmlhLlJJQU1vbmV5VHJhbnNmZXIBbGV5SkRjbVZoZEdWa1QyNGlPakUzTlRrME16QTVORE0wTVRNc0lrTnlaV0YwWldSR2IzSWlPaUl3Tm1RMlltVTFZUzAwTURRMkxURTBNek10WkRnM01DMW1ZVE16TXpZd01ETTNaRElpZlE9PSp6BaT5Fon5lv/bCjHAT3xM6isFLsyOxE0JtobyzgDuaJiiOJ5NT4wpFGBxmZpym5TvtZ+zCuAub+KqTwMFY/8uxZQDlfvWuz2A+EvNFcT5aIAjxk+PhNhrUouudLE='
  },
  amplitudeSessionTimeout: 660000,
  whatsappLink: 'https://wa.me',
  cdmWhatsappNumber: '+60123430034',
  eftDownIntrvalCall: 45000,
  SNHelplineNumber: '200223',
};



// WEBPACK FOOTER //
// ./src/environment/environment.ts